<template>
  <div>
    <renameModal v-if='renameModalShow' :cvToken="renameCvToken" :cvName="renameCvName" @editCvName='editCvName'/>
      <div class="cvs-item-main pointer item dialogWrap" @click.stop="editor" :disabled="!data.can_editable">
        <div class="picture">
          <img
            :src="data.is_mentor ? 'https://files.wondercv.com/service_cv.png' : data.can_editable ? 'https://photo.wondercv.com/cv_doc@2x.png' : require('@/assets/image/grayIcon.png')"
            alt="">
        </div>
        <div class="info">
          <div class="info-title text-overflow">{{renameCvName || data.name || data.cv_name || '未命名超级简历'}}</div>
          <div class="info-property">
            <div class="blue">{{data.lang | langFilter}}</div>
            <div class="red">简历评分：{{ data.score === null ? 40 : data.score }}分</div>
            <div>{{data.cv_type | templateFilter}}</div>
          </div>
          <div class="info-date font-size-14 color-9c text-overflow">最后编辑：{{data.update_time | timeFormatFilter}}</div>
          <div class="option" v-if="data.can_editable" @click.stop>
            <!-- <el-tooltip class="item" effect="dark" content="复制" placement="top">
              <i class="iconfont iconcopy" @click.stop="dumpCv"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="分享" placement="top">
              <i class="iconfont iconexternal-link" @click.stop="share"></i>
            </el-tooltip> -->
            <!-- <el-tooltip class="item" effect="dark" content="投递邮件" placement="top">
              <i class="iconfont iconmail" @click.stop="send"></i>
            </el-tooltip> -->
            <!-- <el-tooltip class="item" effect="dark" content="下载" placement="top">
              <i class="iconfont icondownload" @click.stop="downloadCv"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="修改简历名称" placement="top">
              <i class="iconfont iconsettings" @click.stop="editCvName(data.token, data.cv_name)"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="top" v-if="!data.is_mentor">
              <i class="iconfont icontrash-" @click.stop="deleteCv"></i>
            </el-tooltip> -->
            <div class="icon-wrapper">
              <i class="iconfont iconcopy" @click.stop="dumpCv"></i>
              <span class="dialog">复制</span>
            </div>
            <!-- <div class="icon-wrapper">
              <i class="iconfont iconexternal-link" @click.stop="share"></i>
              <span class="dialog">分享</span>
            </div> -->
            <div class="icon-wrapper">
              <i class="iconfont icondownload" @click.stop="downloadCv"></i>
              <span class="dialog">下载</span>
            </div>
            <div class="icon-wrapper">
              <i class="iconfont iconsettings" @click.stop="editCvName(data.token, data.cv_name)"></i>
              <span class="dialog">修改简历名称</span>
            </div>
            <div class="icon-wrapper">
              <i class="iconfont icontrash-" @click.stop="deleteCv"></i>
              <span class="dialog">删除</span>
            </div>
          </div>
          <div class="option" v-else @click.stop>
            <!-- <el-tooltip class="item" effect="dark" content="下载" placement="top">
              <i class="iconfont icondownload" @click.stop="downloadCv"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="top" v-if="!data.is_mentor">
              <i class="iconfont icontrash-" @click.stop="deleteCv"></i>
            </el-tooltip> -->
            <div class="icon-wrapper">
              <i class="iconfont icondownload" @click.stop="downloadCv"></i>
              <span class="dialog">下载</span>
            </div>
            <div class="icon-wrapper">
              <i class="iconfont icontrash-" @click.stop="deleteCv"></i>
              <span class="dialog">删除</span>
            </div>
          </div>
        </div>
      </div>
    <select-cv
      :cvsEn="cvsEn"
      :cvsCn="cvsCn"
      :isDarkTheme="true"
      v-if="showSelectCv"
      @updated="$emit('updated')"
      @close="showSelectCv = false"/>
  </div>
</template>
<script>
import api from '@/api';
import { dealSignatrue, routerTo } from '@/assets/js/util';
import { mapState, mapMutations } from 'vuex';
import moment from 'moment';
import selectCv from './selectCv';
import renameModal from '@/components/renameModal';
import axios from "axios";
import downloadjs from "downloadjs";
import { get_tUser } from '../../../assets/js/util'
let run = null;
export default {
  name: 'CvsItem',
  components: {
    selectCv,
    renameModal
  },
  props: ['data'],
  data() {
    return {
      moment,
      showSelectCv: false,
      cvsEn: [],
      cvsCn: [],
      isDumpCv: false, // 是否正在复制简历
      isDownloadCv: false, // 是否正在下载简历
      isDeleteCv: false, // 是否正在删除简历
      renameModalShow: false,
      renameCvToken: '', //重命名简历token
      renameCvName: '', //重命名简历名称
    };
  },
  computed: {
    ...mapState('cv', ['cvs']),
    ...mapState('me', [ 'personInfo' ])
  },
  created(){
    this.renameCvName = this.data.cv_name
  },
  methods: {
    ...mapMutations('cv',['setCvs']),
    async editor() {
      let isSelect = await this.available();
      if (isSelect) {
        return false;
      }
      if (!this.data.can_editable) {
        this.showSelectCv = true
        return false;
      }
      routerTo(`/cvs/${this.data.token}/editor`);
    },
    // 会员过去判断简历可用
    async available() {
      let data = this.data;
      if (data.can_editable) {
        return false;
      }
      let cvs = this.cvs;
      let cvsEn = [];
      let cvsCn = [];
      let cvsEnDis = 0; // 英文简历的份数
      let cvsCnDis = 0; // 中文简历的份数
      if (!cvs.length) {
        return false;
      }
      for (let i = 0; i < cvs.length; i++) {
        if (cvs[i].lang === 'cn' && !cvs[i].is_mentor) {
          cvsCn.push(cvs[i]);
          if (cvs[i].can_editable) cvsCnDis++;
        }
        else if (cvs[i].lang === 'en' && !cvs[i].is_mentor) {
          cvsEn.push(cvs[i]);
          if (cvs[i].can_editable) cvsEnDis++;
        }
      }
      this.cvsEn = cvsEn;
      this.cvsCn = cvsCn;
      //
      if ((this.data.lang === 'cn' && cvsCnDis === 0) || (this.data.lang === 'en' && cvsEnDis === 0)) {
        this.showSelectCv = true;
        return true;
      } else if ((this.data.lang === 'cn' && cvsCnDis > 0) || (this.data.lang === 'en' && cvsEnDis > 0)) {
        this.$emit('changeConfirmState', this.downloadCv)
        // this.$store.dispatch('app/setAlertData', {
        //   show: true,
        //   type: 'upVip'
        // })
        return true;
      }
      return false;
    },
    // 会员续费
    // async member() {
    //   let res = await api.cvsV2.membershipOrder({
    //     from_vue: 'true',
    //     improved_order: { package: 'membership' }
    //   });
    //   routerTo(`/orders/${ res.data.order_token }`);
    // },
    // 复制简历
    async dumpCv() {
      clearTimeout(run);
      run = setTimeout(async () => {
        if (this.isDumpCv) {
          return false;
        }
	      let { c_t } = get_tUser()
	      this.isDumpCv = true;
	      let createCv = await api.cvsEditor.canCreateCv(c_t)
	      if (createCv.code === 1000) {
		      if (createCv.data[`can_create_${ this.data.lang }_cv`]) {
			      let loading = this.$message({
				      iconClass: 'el-icon-loading',
				      duration: 0,
				      message: '正在复制'
			      })
			      let params = {
				      cv_token: this.data.token
			      };
			      let res = await api.cvsEditor.duplicateCvs(params);
			      if (res.code === 1000) {
				      this.$message.success('复制成功');
				      //同步到vuex,整理删除之后的数据
				      // let cvsList = this.cvs.filter(item=>item.token!==this.data.token)
				      // this.setCvs(cvsList)
				      this.$emit('updated');
			      } else {
				      this.$message.error(res.message);
				      if (res.code === 3001) {
					      this.$store.dispatch('app/setAlertData', {
						      show: true,
						      type: 'upVip',
                  browseType: 'cvCardCopy'
					      })
				      }
			      }
			      this.isDumpCv = false;
			      loading.close();
		      } else {
			      if (this.personInfo.is_membership) {
				      this.$message.error('已达简历数量上限')
			      } else {
				      this.$store.dispatch('app/setAlertDataShow', false);
				      this.$message.error('已达简历上限，升级会员可创建多份简历');
				      setTimeout(() => {
					      this.$store.dispatch('app/setAlertData', {show: true, type: 'upVip', browseType: 'cvCardCopy'});
				      }, 300);
			      }
			      this.isDumpCv = false;
		      }
	      } else {
		      this.isDumpCv = false;
		      console.log('接口报错')
	      }
      }, 300);
    },
    // 分享
    share() {
      let alertData = {
        show: true,
        type: 'shareCv',
        shareUrl: `${process.env.HOST_ROOT}/cvs/${this.data.token}/share`,
        token: this.data.token
      };
      this.$store.dispatch('app/setAlertData', alertData);
    },
    // 投递
    async send() {
      routerTo(this.data['send_to_email_url'], '_blank');
    },
    // 设置
    editCvName(token, name) {
      console.log(token,name)
      this.renameCvToken = token
      this.renameCvName = name
      this.renameModalShow = !!token
    },
    //刷新简历名字
    refresh(name){
      console.log('refresh')
      this.renameCvName = name
    },
    // 删除简历
    deleteCv() {

      const alertData = {
        show: true,
        type: 'message',
        messageTitle: '删除提示',
        showCancelButton: true, //取消按钮
        showConfirmButton: true, // 确定按钮
        confirmButtonText: '取消',
        cancelButtonText: '删除',
        cancelButtonClass: 'cvs-edit-cancelButtonClass',
        confirmButtonClass: 'cvs-edit-confirmButtonClass',
        messageContent: `
          <p>删除后可在「回收站」中找回最近删除的简历</p>
          <p style="color: #FF453E">确定要删除当前简历吗?</p>
        `,
        confirm: close => {
          close();
        },
        cancel: async close => {
          if (this.isDeleteCv) {
            return false;
          }
          this.isDeleteCv = true;
          let loading = this.$message({
            iconClass: 'el-icon-loading',
            duration: 0,
            message: '正在删除'
          })
          let res = await api.cvsEditor.deleteCv(this.data.token);
          if (res.code === 1000) {
            this.$message.success('删除成功');
            //同步到vuex,整理删除之后的数据
            let cvsList = this.cvs.filter(item=>item.token!==this.data.token)
            this.setCvs(cvsList)
            // this.$store.commit('cvs/GET_CVS', []);
            close();
            this.$emit('updated');
          } else {
            this.$message.error(res.message);
            close();
          }
          this.isDeleteCv = false;
          loading.close();
        }
      };
      this.$store.dispatch('app/setAlertData', alertData);
    },
    // 下载简历
    async downloadCv() {
      if (this.isDownloadCv) {
        return false
      }
      this.isDownloadCv = true
      let downloadLoading =  this.$message({
        message: '正在下载',
        iconClass:'el-icon-loading',
        duration:0,
      });

      let params = {
      	watermark: 'no'
      }
      let res = await api.cvsEditor.downloadCv(this.data.token, params);
      if (!res.data.url) {
        this.$message.error('下载失败');
        this.isDownloadCv = false;
        downloadLoading.close();
        return false;
      }
      axios({
        url: res.data.url,
        method: 'get',
        responseType: 'blob'
      }).then(r => {
        downloadjs(r.data, this.data.cv_name + ".pdf", "pdf");
        this.isDownloadCv = false;
        downloadLoading.close();
        this.$message.success('下载成功');
      }).catch(err => {
        this.isDownloadCv = false;
        downloadLoading.close();
        this.$message.error('下载失败');
      })
    }
  },
}
</script>
<style lang="scss" scoped>
.cvs-item-main {
  width: 100%;
  height: 170px;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 32px;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  &.dialogWrap::before {
    content: "点击进入编辑";
    display: none;
    position: absolute;
    top: -26%;
    left: 50%;
    transform: translateX(-50%);
    color: #fff;
    font-size: 12px;
    white-space: nowrap;
    padding: 9px;
    border-radius: 4px;
    background-color: #000;
  }
  &.dialogWrap::after {
    content: "";
    display: none;
    position: absolute;
    top: -9%;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-right: 6px solid transparent;
    border-left: 6px solid transparent;
    border-top: 6px solid #000;
  }

  .picture {
    width: 120px;
    height: 120px;
    border-radius:6px;
    border:1px solid rgba(222,223,225,1);
    display: flex;
    justify-content: center;
    align-items: center;
    flex: none;
    img {
      display: block;
      width: 40px;
    }
  }
  .info {
    width: calc(100% - 122px);
    height: 120px;
    padding-left: 24px;
    box-sizing: border-box;
    .info-title {
      height: 19px;
      line-height: 19px;
      font-size: 15px;
      font-weight: 700;
      color: #404040;
      margin-top: 2px;
    }
    .info-property {
      margin-top: 16px;
      display: flex;
      align-items: center;
      &>div {
        border-radius: 2px;
        height: 24px;
        line-height: 24px;
        color: #404040;
        font-size: 13px;
        margin-right: 12px;
        background: #F1F2F6;
        padding: 0 14px;
        &.blue {
          background: #D5E8FE;
          color: #4183FE;
        }
        &.red {
          background: #FEE9E9;
          color: #FF4F4C;
        }
      }
    }
    .info-date {
      font-size: 14px;
      color: #9C9C9C;
      margin-top: 45px;
    }
  }
  &:hover {
    box-shadow: 0px 0px 20px #ddd;
    z-index: 2;
    .option {
      display: block;
    }
    &.dialogWrap::before,
    &.dialogWrap::after {
      display: block;
    }
  }

  .option {
    position: absolute;
    bottom: 24px;
    right: 46px;
    display: none;
    .item {
      margin-left: 19px;
    }
    .iconfont {
      font-size: 22px;
      color: #404040;
      font-weight: 600;
      &:hover {
        color: #FF4F4C;
      }
    }

    .icon-wrapper {
      display: inline-block;
      position: relative;
      margin-left: 16px;
      .iconfont {
        font-size: 22px;
        color: #404040;
        font-weight: 600;
      }
      .dialog {
        display: none;
        position: absolute;
        top: -200%;
        left: 50%;
        transform: translateX(-50%);
        color: #fff;
        font-size: 12px;
        white-space: nowrap;
        padding: 8px 10px;
        border-radius: 4px;
        background-color: #000;
        &::after {
          content: "";
          position: absolute;
          left: 50%;
          bottom: -18%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-right: 5px solid transparent;
          border-left: 5px solid transparent;
          border-top: 5px solid #000;
        }
      }
      &:hover{
        .iconfont {
          color: #ff4f4c;
        }
        .dialog {
          display: block;
        }
      }
    }
  }
}

// ::v-deep .cvs-item-main .info .option .item {
//   transition: all 0s;
//   &::before, &::after{
//     transition: all 0s;
//   }
// }
</style>
